import React from 'react';
import classes from './Home10.module.scss';
import { Link } from 'react-router-dom';

const Home10 = () => {
    const heroRef = React.useRef(null);

    // Parallax & Scroll Reveal
    React.useEffect(() => {
        window.scrollTo(0, 0);

        // Parallax scroll handler
        const handleScroll = () => {
            const yOffset = window.scrollY;
            if (heroRef.current) {
                heroRef.current.style.backgroundPositionY = `${yOffset * 0.5}px`;
            }
            
            const parallaxEls = document.querySelectorAll('.js-parallax');
            parallaxEls.forEach(el => {
                const speed = parseFloat(el.getAttribute('data-speed')) || 0.15;
                el.style.transform = `translateY(${yOffset * speed}px)`;
            });
        };
        window.addEventListener('scroll', handleScroll, { passive: true });

        // Intersection Observer for Animations
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(classes.visible);
                    obs.unobserve(entry.target);
                }
            });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

        const animEls = document.querySelectorAll(`.${classes.animate}`);
        animEls.forEach(el => observer.observe(el));

        return () => {
            window.removeEventListener('scroll', handleScroll);
            observer.disconnect();
        };
    }, []);

    // Yappliの導入企業ロゴスライダーをCSSで模倣するためのダミー配列
    const dummyLogos = ['SAISON CARD', 'ANA', 'MUFG', 'KIRIN', 'TOYOTA', 'SONY', 'PANASONIC', 'MITSUI'];
    // 無限スクロール用に2倍にする
    const marqueeItems = [...dummyLogos, ...dummyLogos];
    const featurePanels = [
        {
            image: '/react-assets/home10/home10-feature-nocode.jpg',
            alt: '3台のスマートフォンにアプリ画面が表示されたプロダクト写真',
            title: 'ノーコードで高速開発',
            description: 'UIパーツを組み合わせるだけで、業務アプリを短期間でリリース。試作から本番までを同じフローで進められます。',
            details: [
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-drag.png', text: '部品をドラッグ配置' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-template.png', text: '画面テンプレート活用' }
                },
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-flow.png', text: '遷移を視覚編集' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-preview.png', text: '即時プレビュー確認' }
                }
            ]
        },
        {
            image: '/react-assets/home10/home10-feature-update.jpg',
            alt: 'スマートフォンとノートPCにアプリ開発画面が表示されたプロダクト写真',
            title: '進化し続ける機能',
            description: '管理画面とアプリ画面を連動しながら改善を継続。新機能追加とUI調整を、日々の運用の中で素早く反映できます。',
            details: [
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-update.png', text: 'アップデート即時反映' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-test.png', text: '検証環境で事前確認' }
                },
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-history.png', text: '変更履歴を一元管理' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-team.png', text: 'チーム共同編集対応' }
                }
            ]
        },
        {
            image: '/react-assets/home10/home10-feature-analytics.jpg',
            alt: '複数のスマートフォンに分析UIが表示され斜めに並んだ写真',
            title: 'データに基づく分析',
            description: '利用状況をダッシュボードで可視化し、改善ポイントを素早く特定。意思決定をデータドリブンに切り替えます。',
            details: [
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-flow.png', text: 'KPIをリアルタイム監視' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-preview.png', text: '離脱ポイントを把握' }
                },
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-update.png', text: '異常値を自動通知' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-test.png', text: '改善仮説を高速検証' }
                }
            ]
        },
        {
            image: '/react-assets/home10/home10-feature-support.jpg',
            alt: 'タブレットとスマートフォンに開発ワークフロー画面が表示された写真',
            title: '万全のサポート体制',
            description: '設計から運用まで伴走する支援体制で、導入定着を加速。連携設定や権限設計まで実運用レベルで支援します。',
            details: [
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-template.png', text: '権限と公開範囲を管理' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-flow.png', text: 'API連携を柔軟に拡張' }
                },
                {
                    left: { icon: '/react-assets/home10/icons/home10-icon-update.png', text: 'クラウド運用を最適化' },
                    right: { icon: '/react-assets/home10/icons/home10-icon-team.png', text: '導入後も継続サポート' }
                }
            ]
        }
    ];

    return (
        <div className={classes.root}>
            {/* Header */}
            <header className={classes.header}>
                <div className={classes.logo}>
                    {/* Yappliのロゴ風にテキストで代用。必要に応じて元のSVGに戻す */}
                    <img src="/react-assets/logo-icon.svg" alt="icon" style={{filter: 'grayscale(100%) brightness(0.2)'}} />
                    collabo
                </div>
                <div className={classes.headerRight}>
                    <a href="#download" className={classes.downloadBtn}>資料ダウンロード</a>
                    <div className={classes.hamburger}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </header>

            {/* Hero Section */}
            <section
                ref={heroRef}
                className={classes.hero}
                style={{
                    backgroundImage: "linear-gradient(180deg, rgba(9, 20, 36, 0.14) 0%, rgba(8, 21, 39, 0.42) 62%, rgba(8, 21, 39, 0.58) 100%), url('/react-assets/home10/home10-hero-bg-portrait.jpg')",
                    backgroundPosition: "center 0px"
                }}
            >
                <div className={classes.heroContent}>
                    <div className={`${classes.subBrand} ${classes.animate} ${classes.fadeInUp}`}>collabo <span>webx</span></div>
                    <h1 className={`${classes.catchCopy} ${classes.animate} ${classes.fadeInUp} ${classes.delay1}`}>
                        日本の現場で使える、<br />
                        Web / Appの実行基盤をひとつに。
                    </h1>

                    <div className={`js-parallax ${classes.heroObject} ${classes.animate} ${classes.zoomIn} ${classes.delay2}`} data-speed="0.05">
                        <img src="/react-assets/home10/home10-hero-object.png" alt="日本のオフィスで業務ツールを使う若い女性と男性の透過オブジェクト" />
                    </div>

                    <p className={`${classes.subCopy} ${classes.animate} ${classes.fadeInUp} ${classes.delay3}`}>
                        ノーコードとAIで、開発から運用改善までを高速化。
                    </p>

                    <a href="#more" className={`${classes.ctaButton} ${classes.animate} ${classes.fadeInUp} ${classes.delay4}`}>詳しくはこちら</a>
                </div>
            </section>

            {/* Tabs Section */}
            <div className={classes.tabsWrapper}>
                <div className={classes.tabsScroll}>
                    <div className={`${classes.tab} ${classes.active}`}>アプリ</div>
                    <div className={classes.tab}>Web</div>
                    <div className={classes.tab}>コラボタウン</div>
                    <div className={classes.tab}>モバイルオーダー</div>
                    <div className={classes.tab}>社内システム</div>
                </div>
            </div>

            {/* Client Logo Slider (Social Proof) */}
            <div className={classes.clients}>
                <div className={classes.marquee}>
                    {marqueeItems.map((logo, index) => (
                        <div key={index} className={classes.logoItem}>{logo}</div>
                    ))}
                </div>
            </div>

            {/* Resource Cards Section */}
            <section className={classes.resources}>
                <div className={classes.cardsScroll}>
                    <div className={`${classes.card} ${classes.animate} ${classes.fadeInUp}`}>
                        <div className={`${classes.cardImage} ${classes.hoverZoom}`}>
                            <img src="/react-assets/home10/home10-card-dashboard-main.jpg" alt="日本のオフィスのWebサービスダッシュボード画面" />
                        </div>
                        <div className={classes.cardBody}>
                            <h3 className={classes.cardTitle}>【資料請求はこちら】<br/>collabo丸わかり資料3点セット</h3>
                        </div>
                    </div>
                    <div className={`${classes.card} ${classes.animate} ${classes.fadeInUp} ${classes.delay1}`}>
                        <div className={`${classes.cardImage} ${classes.hoverZoom}`}>
                            <img src="/react-assets/home10/home10-card-meeting.jpg" alt="日本のオフィスで社内アプリを相談する若い女性と男性" />
                        </div>
                        <div className={classes.cardBody}>
                            <h3 className={classes.cardTitle}>社内システムならcollabo<br/>社内エンゲージメント向上</h3>
                        </div>
                    </div>
                    <div className={`${classes.card} ${classes.animate} ${classes.fadeInUp} ${classes.delay2}`}>
                        <div className={`${classes.cardImage} ${classes.hoverZoom}`}>
                            <img src="/react-assets/home10/home10-card-dashboard-side.jpg" alt="日本のオフィスで使われるSaaSダッシュボード" />
                        </div>
                        <div className={classes.cardBody}>
                            <h3 className={classes.cardTitle}>【導入事例】<br/>売上150%UPを実現した秘訣</h3>
                        </div>
                    </div>
                </div>
            </section>

            {/* Big Metrics Typography */}
            <section className={classes.metrics}>
                <h2 className={`${classes.statement} ${classes.animate} ${classes.zoomIn}`}>
                    成果につながる、選ばれるアプリ体験<br />
                    <span className={classes.highlight}>約900</span>の実績が支える、<br />
                    進化するプラットフォーム
                </h2>
            </section>

            {/* Features (特長) */}
            <section className={classes.featuresBlock}>
                <div className={`${classes.sectionHeader} ${classes.animate} ${classes.fadeInUp}`}>
                    <h2 className={classes.sectionTitle}>collabo 4つの特長</h2>
                    <p className={classes.sectionSub}>ビジネスを躍進させる、圧倒的な利便性と拡張性</p>
                </div>
                <div className={classes.featuresGrid}>
                    {featurePanels.map((feature, index) => {
                        return (
                        <div className={`${classes.featureCard} ${classes.animate} ${classes.fadeInUp}`} key={feature.title}>
                            <div className={`${classes.featureIcon} ${classes.hoverZoom}`}>
                                <img src={feature.image} alt={feature.alt} />
                            </div>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                            <div className={classes.featureMeta}>
                                {feature.details.map((pair, index) => (
                                    <div className={classes.featureMetaPair} key={`${feature.title}-${index}`}>
                                        <div className={classes.featureMetaIcons}>
                                            <span className={classes.metaIcon}>
                                                <img className={classes.metaIconImage} src={pair.left.icon} alt="" />
                                            </span>
                                            <span className={classes.metaIcon}>
                                                <img className={classes.metaIconImage} src={pair.right.icon} alt="" />
                                            </span>
                                        </div>
                                        <div className={classes.featureMetaTexts}>
                                            <span>{pair.left.text}</span>
                                            <span>{pair.right.text}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )})}
                </div>
            </section>

            {/* News / イベント */}
            <section className={classes.newsBlock}>
                <div className={`${classes.sectionHeader} ${classes.animate} ${classes.fadeInUp}`}>
                    <h2 className={classes.sectionTitle}>お知らせ</h2>
                </div>
                <ul className={classes.newsList}>
                    <li className={`${classes.animate} ${classes.fadeInUp}`}>
                        <span className={classes.date}>2024.04.01</span>
                        <span className={classes.category}>リリース</span>
                        <a href="#news">新機能「コラボAIアシスタント」の提供を開始しました</a>
                    </li>
                    <li className={`${classes.animate} ${classes.fadeInUp} ${classes.delay1}`}>
                        <span className={classes.date}>2024.03.15</span>
                        <span className={classes.category}>イベント</span>
                        <a href="#news">【ウェビナー】DX推進のための社内アプリ活用術（4/20開催）</a>
                    </li>
                    <li className={`${classes.animate} ${classes.fadeInUp} ${classes.delay2}`}>
                        <span className={classes.date}>2024.03.01</span>
                        <span className={classes.category}>お知らせ</span>
                        <a href="#news">導入企業数が500社を突破いたしました</a>
                    </li>
                </ul>
                <div className={`${classes.newsMore} ${classes.animate} ${classes.fadeInUp} ${classes.delay3}`}>
                    <a href="#news">お知らせ一覧へ <span>&rarr;</span></a>
                </div>
            </section>

            {/* Bottom CTA */}
            <section className={classes.bottomCta}>
                <div className={`${classes.ctaContainer} ${classes.animate} ${classes.zoomIn}`}>
                    <h2>アプリ開発の常識を変える。<br/>まずは資料でご確認ください。</h2>
                    <div className={classes.ctaButtons}>
                        <a href="#download" className={classes.btnPrimary}>無料で資料請求する</a>
                        <a href="#contact" className={classes.btnSecondary}>オンライン相談を予約する</a>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className={classes.footer}>
                <div className={classes.slogan}>Practical DX for Every Team</div>
                
                <div className={classes.footerLinks}>
                    <a href="#company">運営会社</a>
                    <Link to="/privacy">プライバシーポリシー</Link>
                    <a href="#contact">お問い合わせ</a>
                </div>

                <div className={classes.companyInfo}>
                    <div className={classes.name}>コラボ株式会社 (collabo Inc.)</div>
                    <p>
                        〒921-8163<br />
                        石川県金沢市横川7丁目26
                    </p>
                    <p style={{marginTop: '10px'}}>&copy; {new Date().getFullYear()} collabo Inc.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home10;
